import React from 'react';
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {useSelector} from "react-redux";
import {SalesPaymentAccessTypes} from "../../../../enum/organizationBinding/OrganizationBindingWrapper";
import ReactSelect from "react-select";

const SelectSalesPaymentAccessType = ({onChange, defaultSalesPaymentAccessType}) => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const options = SalesPaymentAccessTypes;

    return (
        <ReactSelect options={options}
                     isSearchable={false}
                     placeholder={t(lang, 'items.common.select')}
                     getOptionLabel={option => t(lang, option.label)}
                     getOptionValue={(option) => option.value}
                     onChange={(option) => onChange(option.value)}
                     value={options.find(o => o.value === defaultSalesPaymentAccessType) || null}
        />
    );
};

export default SelectSalesPaymentAccessType;